import React, { useState, useEffect } from 'react';
import Imagen1 from '/home/nadai/Nadai App Starknet Test/src/Pokecairo.jpeg';
import Imagen2 from '/home/nadai/Nadai App Starknet Test/src/Pathfinder.png';
import Imagen3 from '/home/nadai/Nadai App Starknet Test/src/Challenge.png';
import Imagen4 from '/home/nadai/Nadai App Starknet Test/src/Cocecha.png';
import Imagen5 from '/home/nadai/Nadai App Starknet Test/src/Nadai.png';


const StarkNetEs = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [images] = useState([
    { url: Imagen1, title: 'PokeCairo Card', alt: 'PokeCairo Card', information: 'Cartas de PokeCairo es una colección de NFT (sin valor real) basada en el primer paquete de los juegos originales de Pokémon. Esto NO está destinado a ningún tipo de beneficio monetario, es simplemente por diversión y para aprender más sobre el ecosistema Blockchain/Starknet. En principio el set base contiene 102 cartas, pero en este caso quitaremos las cartas de entrenador y energía (quedan un total de 69 cartas).', link: 'https://pokecairo-cards.com/' },
    { url: Imagen2, title: 'Pathfinders - Búsqueda de puntos de salto en El Cairo -', alt: 'Pathfinders - Búsqueda de puntos de salto en El Cairo -', information: 'Este proyecto fue desarrollado para el MatchBoxDAO Hackathon, la idea es desarrollar en Cairo un algoritmo que resuelva el problema de búsqueda de rutas para un mapa representado en grillas 2D. El mapa puede contener obstáculos, además suponemos que el movimiento en las casillas es bidireccional con un coste de movimiento uniforme.', link: 'https://dpinones.github.io/pathfinding-visualizer/' },
    { url: Imagen3, title: 'Security Challenge Factory for Starknet', alt: 'Security Challenge Factory for Starknet', information: 'Security Challenge Factory para Starknet por devnet0x. Inspirado en Ethereum Capture the Ether, este es un juego en el que pirateas contratos inteligentes de Starknet para aprender sobre seguridad. Está destinado a ser tanto divertido como educativo. Este juego fue creado en su versión original de Solidity por @smarx, quien escribe en un blog sobre el desarrollo de contratos inteligentes en Program the Blockchain y ahora está siendo adaptado a la red Starknet por @devnet0x.', link: 'https://starknet-challenges.vercel.app/'},
    { url: Imagen4, title: 'Cocecha Starknet', alt: 'Cocecha Starknet', information: 'Cocecha es una solucion que le permite a los pequeños y medianos productores de cannabis simlificar el proceso de obtención de licencias. Connectarse a los reguladores a través de una API para someter sus documentos a aprobacion y obtener Certificado de NFT creado en la red Starknet', link: 'https://www.figma.com/proto/gipiEHPom58Bpw6pHrm1aM/cosecha?embed_host=share&kind=&node-id=1%3A24&page-id=0%3A1&scaling=min-zoom&starting-point-node-id=1%3A24&viewport=2759%2C1739%2C0.41' },
    { url: Imagen5, title: 'Nadai dApp Starknet', alt: 'Nadai dApp Starknet', information: 'Esta dApp es una prueba inicial que recoje algunos de las principales solcuiones de escalibilidad de ETH. También encontrará todos el material educativo de L2 En Español y StarknetEs, así como guías de GITHUB Nadai para Starknet-Edu y otros ajustes de Cairo', link: 'https://nadai-app-l2.vercel.app/#' },
  ]);

  const toggleModal = (index) => {
    setModalIsOpen(!modalIsOpen);
    setImageIndex(index);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setImageIndex(prevIndex => (prevIndex + 1) % images.length);
    }, 10000);
    return () => clearInterval(intervalId);
  }, [images.length]);

  const changeImage = (direction) => {
    setImageIndex((prevIndex) => {
      return (prevIndex + direction + images.length) % images.length;
    });
  };

 return (
  <>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', width: '80%', }}>
        <img
          src={images[imageIndex].url}
          alt={images[imageIndex].alt}
          style={{ height: '400px', width: '400px', borderRadius: '100px',  margin: '15px',  marginTop: '0px', cursor: 'pointer', transition: 'transform .3s' }}
          onClick={() => toggleModal(imageIndex)}
          onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"}
          onMouseLeave={e => e.currentTarget.style.transform = "scale(1.0)"}
        />
        
        <img
          src={images[(imageIndex + 1) % images.length].url}
          alt={images[(imageIndex + 1) % images.length].alt}
          style={{ height: '400px', width: '400px', borderRadius: '100px',  margin: '15px',  marginTop: '0px', cursor: 'pointer', transition: 'transform .3s' }}
          onClick={() => toggleModal((imageIndex + 1) % images.length)}
          onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"}
          onMouseLeave={e => e.currentTarget.style.transform = "scale(1.0)"}
        />
      </div>
    </div>

    {modalIsOpen && (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
        <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '10px', maxWidth: '80%', maxHeight: '80%' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button onClick={() => toggleModal(imageIndex)}>X</button>
          </div>
          <h3>{images[imageIndex].title}</h3>
          {images[imageIndex].information}
          <a href={images[imageIndex].link}>{images[imageIndex].link} </a>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button style={{ margin: "8px", padding: "5px", backgroundColor: "#d7d7f8b3", borderRadius: "5px" }} 
             onClick={() => changeImage(-1)}>Previous</button>
          <button style={{ margin: "8px", padding: "5px", backgroundColor: "#d7d7f8b3", borderRadius: "5px" }} 
             onClick={() => changeImage(+1)}>Next</button>
          </div>
        </div>
      </div>
    )}
  </>
);
};

export default StarkNetEs;
